// @flow

import { connect } from 'react-redux';
import home1 from '../../images/home/home_image1.jpg';
import home2 from '../../images/home/home_image2.jpg';
import home3 from '../../images/home/home_image3.jpg';
import home4 from '../../images/home/home_image4.jpg';
import home5 from '../../images/home/home_image5.jpg';
import home6 from '../../images/home/home_image6.jpg';
import { openMembershipModal } from '../../services/ui';

import Home from './home';
import { User } from '../../models/user';

export type Props = {
  location: RouteComponentProps,
  user: User,
};

export const getImage: any = (imageNumber: number) => {
  switch (imageNumber) {
    case 1:
      return home1;
    case 2:
      return home2;
    case 3:
      return home3;
    case 4:
      return home4;
    case 5:
      return home5;
    case 6:
      return home6;
    default:
      return home1;
  }
};

const mapState = ({ authentication }) => ({
  user: authentication.user,
  authenticating: authentication.authenticating,
});

const mapDispatch = {
  openMembershipModal,
};

export default connect(
  mapState,
  mapDispatch,
)(Home);
